module.exports = __webpack_public_path__ + "media/images/frontend/covid19_01-1209bd795f6d9895c3e5875603cd00b8.jpg";